/**
 * Texto ÚNICO do motivo pelo qual o
 * cliente em foco está travado nesta conversa — antes nenhuma das 3
 * superfícies (chip do composer, cartão acima das mensagens, item do
 * palette Ctrl+K) explicava o motivo, só esmaeciam/escondiam a ação.
 *
 * Arquivo PRÓPRIO, não `constants/TextChat.js` (em edição por outro dev
 * nesta mesma rodada) — mesmo padrão de `Text.memoria.js`/`Text.aprendizado.js`
 * (arquivo dedicado, consumido por import direto).
 *
 * Consumidores hoje: `components/escopo-select/escopo-select.vue` (tooltip
 * do chip), `global/modal/ia-palette/ia-palette-item.vue` (title do item de
 * CLIENTE, só ele — agente/modelo travam por outra regra e têm outro motivo)
 * e `components/chat-cliente-escopo/` (a linha compacta acima das mensagens:
 * `title` quando travada + `rotulo`). Chip e palette não têm ação de
 * troca ao lado do texto — daí "abra outra conversa" ser o conselho certo
 * para eles.
 */
export const ESCOPO_CLIENTE_TEXT = {
  motivoTravamento:
    'Cliente fixado nesta conversa: abra outra conversa para falar de outro cliente.',
  /**
   * [design it.4, SHOULD] `chat-cliente-escopo.vue::.cliente-escopo__travado-
   * info` reusava `motivoTravamento` ("abra outra conversa...") bem ABAIXO
   * do botão "Trocar" (`.cliente-escopo__aviso`) — que FUNCIONA nesta MESMA
   * conversa (spec-009 [T006/US-2]). A linha negava uma ação que o próprio
   * cartão oferece um parágrafo acima. Chave PRÓPRIA, exclusiva do cartão —
   * `motivoTravamento` (chip/palette, sem Trocar por perto) não muda.
   */
  motivoTravamentoComTroca:
    'Cliente fixado nesta conversa: use Trocar para falar de outro cliente.',
  /**
   * 14/09/2026 — a linha compacta de `chat-cliente-escopo.vue` diz o que o
   * cliente em foco COBRE, em vez do título "Cliente em foco". Copy FIXA:
   * o escopo é o mesmo para qualquer cliente (cadastro, carteira, tarefas e
   * contatos são as fontes que as tools de cliente consultam); não vem do
   * servidor nem varia por agente.
   */
  // O rótulo que o cartão sempre teve (era o título das 3 linhas; na linha
  // compacta de 14/09/2026 vira o texto do meio). Nada inventado aqui.
  rotulo: 'Cliente em foco',
  /**
   * ★ [spec-009 T013, US-3] Escolher o cliente no chip VINCULA os anexos que
   * já haviam subido sem dono — e a tela precisa dizer QUAIS.
   *
   * Vincular em silêncio é o mesmo defeito que o descarte silencioso, só do
   * outro lado: um arquivo muda de dono (isto é, passa a valer para um
   * cadastro) sem que ninguém veja. Por isso a frase nomeia cada arquivo e o
   * cliente, e diz o que o consultor ganha com isso — não precisar reanexar.
   *
   * `nomes` é `string[]` (o nome do arquivo como o consultor o vê no disco).
   */
  // ⚠️ `cliente` pode chegar vazio: quem chama passa `cliente.name || ''`, e a
  // lista de clientes nem sempre traz o nome (o chip resolve por id). Com a
  // interpolação crua isso virava *"… foi vinculado a  — a IA usa…"*, com o
  // buraco à vista. `destinoDoAnexo` (send-message.vue) já resolvia o mesmo
  // caso suprimindo a frase; aqui a frase precisa existir, então some só o
  // trecho do nome.
  anexosVinculados: (nomes, cliente) => {
    const lista = (nomes || []).map((nome) => `"${nome}"`).join(', ')
    const aoCliente = cliente ? ` a ${cliente}` : ''
    if ((nomes || []).length === 1) {
      return `${lista} foi vinculado${aoCliente}. A IA usa o arquivo que você já enviou, sem reanexar.`
    }
    return `${nomes.length} arquivos foram vinculados${aoCliente}: ${lista}. A IA usa os arquivos que você já enviou, sem reanexar.`
  },
}
